import React, { Component } from "react";
import { Row, Col, Button, Image } from "antd";
import pdfFile from "./mornaResume.pdf";
import "../App.css";

export default class Aboutme extends Component {
  download = () => {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = "mornaYangResume.pdf"; // 你可以根据需要更改文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    return (
      <Row className="aboutPage">
        <Col xs={1} sm={1} md={2} lg={2} xl={2}></Col>
        <Col xs={22} sm={22} md={20} lg={20} xl={20}>
          <Row>
            <Col span={24} className="aboutBody">
              <Row>
                <Col span={24} className="aboutDownload">
                  <Button onClick={this.download} type="Link">
                    Download Resume
                  </Button>
                </Col>
                <Col span={24}>
                  {/* <div className="aboutTitle">
                    <div className="color72">Morna</div>
                    <div> &nbsp;Zixie Yang</div>
                  </div> */}
                  <div className="aboutTitle">
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/NameLogo.svg`}
                      alt="Name Logo"
                      className="aboutNameImg"
                      width={300}
                      preview={false}
                    />
                  </div>
                </Col>
                <Col span={24}>
                  <div className="aboutSubTitle">
                    VISUAL DEVELOPMENT &amp; BACKGROUND ARTIST
                  </div>
                </Col>
                <Col span={24}>
                  <Row>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                      <Row>
                        <Col>
                          <div className="aboutRowTitle">EDUCATION</div>
                        </Col>
                        <Col span={24} className="aboutRowBody color72">
                          <div className="color00">
                            ArtCenter College of Design
                          </div>
                          <div>Bachelor in Illustration</div>
                          <div>Entertainment Art</div>
                          <div>2021-2025</div>
                        </Col>
                        <Col>
                          <div className="aboutRowTitle">
                            AWARDS &amp; RECOGNITIONS
                          </div>
                        </Col>
                        <Col span={24} className="aboutRowBody color72">
                          <div>ArtCenter UG Scholarships</div>
                          <div>ArtCenter Gallery</div>
                          <div>Beyond Supersonic Gallery</div>
                          <div>Distinction (GPA 3.80+)</div>
                        </Col>
                        <Col>
                          <div className="aboutRowTitle">CONTACT</div>
                        </Col>
                        <Col span={24} className="aboutRowBody color72 f2EM">
                          <div>
                            <a
                              href="mailto:morna0427@gmail.com"
                              className="link"
                            >
                              morna0427@gmail.com
                            </a>
                          </div>
                          <div>
                            Linkedin:
                            <a
                              href="https://www.linkedin.com/in/morna-yang-b17b69290/"
                              target="_blank"
                              className="link"
                            >
                              Morna(Zixie) Yang
                            </a>
                          </div>
                          <div>
                            Websites:
                            <a
                              href="https://mornayangportfolio.com/"
                              className="link"
                            >
                              mornayangportfolio.com
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24} sm={12} md={16} lg={16} xl={16}>
                      <Row>
                        <Col>
                          <div className="aboutRowTitle">EXPERIENCE</div>
                        </Col>
                        <Col span={24} className="aboutRowBody">
                          <div>
                            <span className="fBold fHN">
                              Nikon Optical Instrument (china) Co., Ltd.
                            </span>
                          </div>
                          <div>Summer Intern 07/2023 - 08/2023</div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Assist the marketing team brainstorming ideas
                                for promotional posters and merchandise.
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              Indie Game Alex’s Painter Dream
                            </span>
                            &nbsp;| 06/2024 - 05/2025
                          </div>
                          <div>
                            Collaborate with Strategic Operator Garena Dharmawan
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Design and develop game asset including
                                characters, props, ui, illustrations, animation
                                and backgrounds.
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              Ciga 48 Hours Game Jam
                            </span>
                            &nbsp;| 07/2024
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Designed and developed gaming characters,
                                animation, ui, illustration and backgrounds.
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              ArtCenter College of Design
                            </span>
                          </div>
                          <div>Teacher&#39;s Assistant | 2024 - 2025</div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Assist in student work critiques, organizing
                                class activities and Canvas assignments.
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">Global Game Jam</span>
                            &nbsp;| 01/2025
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Responsible for team recruitment, team
                                organization and create all visual elements of
                                the game.
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              Ru Yue Er Zhi Art Studio(如乐⽽⾄⼯作室）
                            </span>
                          </div>
                          <div>Graphic Designer | 12/2024 - 01/2025</div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Design Logo, poster and advertising materials
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                      <Row>
                        <Col>
                          <div className="aboutRowTitle">COURSES</div>
                        </Col>
                        <Col span={24} className="aboutRowBody">
                          <div className="fBold">Intro to Entrepreneurship</div>
                          <div className="color72">Instructor: Kevin Beard</div>
                          <div className="fBold">Child-Center Research</div>
                          <div className="color72">
                            Instructor: Krystina Castella
                          </div>
                          <div className="fBold">Visual Development</div>
                          <div className="color72">
                            Instructor: Cliff Nielsen
                          </div>
                          <div className="fBold">Inventive Drawing</div>
                          <div className="color72">
                            Instructor: Bill Perkins
                          </div>
                        </Col>
                        <Col>
                          <div className="aboutRowTitle">
                            PROFICIENT SOFTWARE
                          </div>
                        </Col>
                        <Col span={24} className="aboutRowBody color72">
                          <div>Adobe Creative Suite,</div>
                          <div>Procreate, Blender, Maya,</div>
                          <div>Sketchup, Unity, Stable</div>
                          <div>Diffusion, Spine, Live2d</div>
                        </Col>
                        <Col>
                          <div className="aboutRowTitle">
                            LANGUAGE PROFICIENCY
                          </div>
                        </Col>
                        <Col span={24} className="aboutRowBody color72">
                          <div>English - Professional</div>
                          <div>Mandarin - Native</div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24} sm={12} md={16} lg={16} xl={16}>
                      <Row>
                        <Col>
                          <div className="aboutRowTitle">SKILLS</div>
                        </Col>

                        <Col span={24} className="aboutRowBody">
                          <div>
                            <span className="fBold fHN">
                              Digital illustration and Concept Design:
                            </span>
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Proficient in Visual Narrative, character design
                                and world building for games and animation
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              Asset Mapping and UI:
                            </span>
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Proficient in creating stylized and realistic
                                environments, props, and coherent game
                                interfaces
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">Unity(C#):</span>
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Familiarity with game engine workflows; ability
                                to prototype, visualize and script interactive
                                elements
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">3D modelling:</span>
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Basic modelling and UV mapping of assets using
                                tools such as Maya/Blender/Substance
                              </li>
                            </ul>
                          </div>
                          <div>
                            <span className="fBold fHN">
                              AI Creative Tools:
                            </span>
                          </div>
                          <div>
                            <ul className="aboutUlBody color72">
                              <li>
                                Assisted workflows - Adaptive use of AI tools to
                                increase the speed of iteration and concept
                                development
                              </li>
                              <li>
                                Familiar with collaborating with different
                                departments, able to work in fast pace
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} className="rH100"></Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={1} sm={1} md={2} lg={2} xl={2}></Col>
      </Row>
    );
  }
}
